import React, { useRef } from "react";
import { Col } from "antd";
import { useTranslation } from "react-i18next";

import { DownloadIcon } from "icons";
import { generateImg } from "utils";

import {
  BoxHeader,
  BoxItem4DisorderChart,
  WrapperInformation,
  WrapperConsultation,
} from "../Dashboard.style";

const ConsultationStatistical = ({ data }: any) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "dashboard",
  });

  const imgRef = useRef<any>();

  return (
    <Col xs={24} md={24} xl={12} ref={imgRef} style={{ zIndex: 0 }}>
      <BoxItem4DisorderChart>
        <BoxHeader>
          <div></div>
          <DownloadIcon
            fill="#3B3B3B"
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={(event: any) => {
              if (!event.detail || event.detail == 1) {
                generateImg("physical-disorder", imgRef.current);
              }
            }}
          />
        </BoxHeader>
        <WrapperConsultation>
          <img src="/images/consultation.png" alt="consultation" />
          <WrapperInformation>
            <div>
              <div>{t("several-consultations")}</div>
              <div>{t("local")}</div>
              <div>{t("whole")}</div>
              <div>{t("mental")}</div>
            </div>
            <div>
              <div style={{ fontWeight: 700 }}>{data.consultation_count}</div>
              <div>{data.body_part_count}%</div>
              <div>{data.entire_body_part_count}%</div>
              <div>{data.mental_count}%</div>
            </div>
          </WrapperInformation>
        </WrapperConsultation>
      </BoxItem4DisorderChart>
    </Col>
  );
};

export default ConsultationStatistical;
